export default __webpack_public_path__ + "static/award6-7326d1611991efd9acb6e17447a02b94.jpg";